<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger" [class.-is-open]="isPanelOpened" (click)="isPanelOpenedChange.emit(!isPanelOpened)" #trigger>
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Section title@@customerOverviewComponent.heading.history'>History</span>
    </h4>
  </div>
  <div class="esf-accordion__target" [hidden]="!isPanelOpened">

    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">
        <table *ngIf="activityHistory.length && !loadingActivityHistory" class="esf-table">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head"
                  i18n-data-label='Table cell heading@@general.tableCellLabel.date' data-label="Date">
                <span i18n='Table cell heading@@general.tableCellLabel.date'
                      class="esf-table__cell-inner">Date</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head"
                  i18n-data-label='Table cell heading@@general.tableCellLabel.action' data-label="Action">
                <span i18n='Table cell heading@@general.tableCellLabel.action'
                      class="esf-table__cell-inner">Action</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head"
                  i18n-data-label='Table cell heading@@general.tableCellLabel.old' data-label="Old">
                <span i18n='Table cell heading@@general.tableCellLabel.old' class="esf-table__cell-inner">Old</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head"
                  i18n-data-label='Table cell heading@@general.tableCellLabel.new' data-label="New">
                <span i18n='Table cell heading@@general.tableCellLabel.new' class="esf-table__cell-inner">New</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head"
                  i18n-data-label='Table cell heading@@general.tableCellLabel.author' data-label="Author">
                <span i18n='Table cell heading@@general.tableCellLabel.author'
                      class="esf-table__cell-inner">Author</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row" *ngFor="let activity of activityHistory">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.date'
                  data-label="Date">
                <span class="esf-table__cell-inner">{{ activity.createdAt | date: 'dd.MM.yyyy - H:mm' }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.action'
                  data-label="Action">
                <span class="esf-table__cell-inner">{{ getTranslatedKeyValue(activity.type) }} {{ getTranslatedKeyValue(activity.objectType) }}</span>
              </td>
              <td class="esf-table__cell esf-table__cell--break-word" i18n-data-label='Table cell heading@@general.tableCellLabel.old'
                  data-label="Old">
                <ng-container *ngFor="let changedField of activity.diffs | evObjectKeys">
                  <div class="esf-table__cell-inner" style="max-width: 200px;">
                    <strong>{{ getTranslatedKeyValue(changedField) }}</strong>
                    <span [ngSwitch]="changedField">
                      <span *ngSwitchCase="'birthday'">: {{ activity.diffs[changedField]['old'] | date: 'dd.MM.yyyy' }}</span>
                      <span *ngSwitchCase="'mergedAt'">: {{ activity.diffs[changedField]['old'] | date: 'dd.MM.yyyy' }}</span>
                      <span *ngSwitchCase="'salutation'">: {{ (activity.diffs[changedField]['old'] | titlecase) }}</span>
                      <span *ngSwitchDefault>: {{ activity.diffs[changedField]['old'] }}</span>
                    </span>
                  </div>
                </ng-container>
              </td>
              <td class="esf-table__cell esf-table__cell--break-word" i18n-data-label='Table cell heading@@general.tableCellLabel.new'
                  data-label="New">
                <ng-container *ngFor="let changedField of activity.diffs | evObjectKeys">
                  <div class="esf-table__cell-inner" style="max-width: 200px;">
                    <strong>{{ getTranslatedKeyValue(changedField) }}</strong>
                    <span [ngSwitch]="changedField">
                      <span *ngSwitchCase="'birthday'">: {{ activity.diffs[changedField]['new'] | date: 'dd.MM.yyyy' }}</span>
                      <span *ngSwitchCase="'mergedAt'">: {{ activity.diffs[changedField]['new'] | date: 'dd.MM.yyyy' }}</span>
                      <span *ngSwitchCase="'salutation'">: {{ (activity.diffs[changedField]['new'] | titlecase) }}</span>
                      <span *ngSwitchDefault>: {{ activity.diffs[changedField]['new'] }}</span>
                    </span>
                  </div>
                </ng-container>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.author'
                  data-label="Author">
                <span [ngSwitch]="activity.blameUserName">
                  <span class="esf-table__cell-inner" *ngSwitchCase="null">TIXX.Connect</span>
                  <span class="esf-table__cell-inner" *ngSwitchDefault>{{ activity.blameUserName }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="esf-table" *ngIf="activityHistory.length === 0 && !loadingActivityHistory">
          <section class="esf-empty-state flex-empty-state">
            <div>
              <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
                <use xlink:href="#esf-icon-clock-redo"></use>
              </svg>
            </div>
            <p class="esf-paragraph">
              <small i18n='Results output if no logged activity@@customerOverviewComponent.results.noActivityLogged'>No logged activity for this customer.</small>
            </p>
          </section>
        </table>

        <div class="esf-pagination" *ngIf="pager && activityHistory.length && !loadingActivityHistory">
          <a (click)="setPage(pager.currentPage - 1)" class="esf-pagination__arrow"
             [ngClass]="{disabled:pager.currentPage === 1}">
            <svg class="esf-icon esf-icon--darkest" width="16" height="16">
              <use xlink:href="#esf-icon-minimal-left"></use>
            </svg>
          </a>
          <div class="esf-pagination__pages">
            <a (click)="setPage(1)" class="esf-pagination__page" *ngIf="pager.currentPage > 3">1</a>
            <span *ngIf="pager.currentPage > 3" class="esf-pagination__dots">...</span>
            <a (click)="setPage(page)" class="esf-pagination__page esf-pagination__page--neighbor"
               *ngFor="let page of pager.pages" [ngClass]="{'-is-current':pager.currentPage === page}">{{ page }}</a>
            <span *ngIf="pager.totalPages - pager.currentPage >= 3" class="esf-pagination__dots">...</span>
            <a (click)="setPage(pager.totalPages)" class="esf-pagination__page"
               *ngIf="pager.totalPages - pager.currentPage >= 3">{{ pager.totalPages }}</a>
          </div>
          <a (click)="setPage(pager.currentPage + 1)" class="esf-pagination__arrow"
             [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
            <svg class="esf-icon esf-icon--darkest" width="16" height="16">
              <use xlink:href="#esf-icon-minimal-right"></use>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
